import axios from 'axios';
import auth0 from '../auth/authWrapper';

declare const DEV_BYPASS_AUTH: string | undefined;
declare const DEV_API_KEY: string | undefined;

export const creatorDomain = CREATOR_HOST;

const isDevBypass = typeof DEV_BYPASS_AUTH !== 'undefined' && DEV_BYPASS_AUTH === 'true' && typeof DEV_API_KEY !== 'undefined' && DEV_API_KEY;

export const httpClient = axios.create({
        baseURL: BASE_URL,
        headers: {
                'Content-Type': 'application/json',
        },
});

httpClient.interceptors.request.use(
        async (config) => {
                if (isDevBypass) {
                         
                        config.headers['x-api-key'] = DEV_API_KEY;
                } else if (auth0) {
                        try {
                                const token = auth0.idTokenClaims.value?.__raw;

                                // Only attach the Authorization header when a token is
                                // actually available. Sending `AdminBearer undefined`
                                // causes the backend to respond 400 "Invalid token",
                                // which the response interceptor turns into a login
                                // redirect — feeding the production redirect loop.
                                if (token) {
                                        config.headers.Authorization = `AdminBearer ${token}`;
                                }
                        } catch (error) {
                                console.error(
                                        'Error getting access token:',
                                        error,
                                );
                        }
                }

                return config;
        },

        (error) => Promise.reject(error),

);

// Flag to prevent multiple redirect attempts when several API calls fail simultaneously
let isRedirectingToLogin = false;

httpClient.interceptors.response.use(
        (response) => response,
        async (error) => {
                // Check for 400 error with "Invalid token" message
                if (
                        error.response?.status === 400 &&
                        error.response?.data?.error?.message === 'Invalid token' &&
                        !isRedirectingToLogin &&
                        !isDevBypass
                ) {
                        isRedirectingToLogin = true;
                        console.warn('Invalid token detected, redirecting to login...');
                        await auth0.loginWithRedirect();
                }
                return Promise.reject(error);
        },
);
